import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import useSiteCopySelector from 'components/useSiteCopySelector';
import EvidenceTooltip from 'containers/TopicCenter/components/Menu/EvidenceTooltip';
import Box from '@material-ui/core/Box';
import { Divider, Typography } from '@material-ui/core';
import ArrowRight from './images/arrow-right.svg';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
  },
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '8px 0',
    flex: '1 1 auto',
    '& div': {
      marginLeft: 0,
    },
    '@media (min-width: 960px) and (max-width: 1200px)': {
      marginLeft: 0,
    },
  },
  withIcon: {
    marginLeft: 0,
  },
  icon: {
    marginRight: 15,
    '@media (min-width: 960px) and (max-width: 1200px)': {
      display: 'none',
      marginRight: 0,
    },
  },
  link: {
    fontFamily: 'MadaRegular',
    fontSize: 14,
    color: '#01619B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '@media (min-width: 960px) and (max-width: 1025px)': {
      fontSize: 15,
    },
  },
  arrow: {
    marginRight: 15,
  },
  divider: {
    marginTop: 20,
    background: '#E9ECED',
  },
}));

function Approaches({ data }) {
  const classes = useStyles();
  const [showMore, setShowMore] = useState(false);
  const approachesData = _get(data, 'all');
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  if (!approachesData.length) return null;
  const hasMore = approachesData.length > 3;
  const dataToShow = showMore ? approachesData : approachesData.slice(0, 3);
  return (
    <Box component="div" display="flex" flexDirection="column" mt="20px">
      <Typography className={classes.title}>
        {_get(resourceItemPageSiteCopy, 'pageCopy.taggedApproachesHeader')}
      </Typography>
      {dataToShow
        .filter(({ show }) => show)
        .map(({ name, slug, icon }) => (
          <Grid
            item
            xs={12}
            className={ClassNames(classes.root, { [classes.withIcon]: icon })}
            key={slug}
          >
            {icon && (
              <EvidenceTooltip tooltipId={`evidence-${name}`} position="right">
                <img src={icon} alt={name} className={classes.icon} />
              </EvidenceTooltip>
            )}
            <Link to={`/topics/${slug}`} className={classes.link}>
              {name}
            </Link>
          </Grid>
        ))}
      {hasMore && (
        <Grid item xs={12} className={classes.root}>
          <ButtonBase
            disableRipple
            className={classes.link}
            onClick={() => setShowMore(!showMore)}
          >
            <img src={ArrowRight} alt="" className={classes.arrow} />
            {showMore
              ? _get(
                  resourceItemPageSiteCopy,
                  'pageCopy.leftPanelApproachesShowLess',
                )
              : _get(
                  resourceItemPageSiteCopy,
                  'pageCopy.leftPanelApproachesShowMore',
                )}
          </ButtonBase>
        </Grid>
      )}
      <Divider className={classes.divider} />
    </Box>
  );
}

Approaches.propTypes = {
  data: PropTypes.object,
};

export default React.memo(Approaches);
